import React, { Component } from "react";

import ComponentSelector from "../utils/components/ComponentSelector";
import ControlRow from "../utils/components/ControlRow";
import DriversTable from "./DriversTable";
import GroupsTable from "./GroupsTable";

import { searchModule } from "../utils/Utils";

import "../../styles/utils/_loadingScreen.scss";
import "../../styles/components/evs/Drivers.scss";

class Drivers extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      selectedTab: 0,
      search: "",
    };

    this.selectTab = this.selectTab.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  selectTab(e, tabIndex) {
    this.safeSetState({
      selectedTab: tabIndex,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="drivers" className="main-container">
        <div className="control-bar">
          <ControlRow
            search={this.state.search}
            onSearchChange={e => searchModule.setSearch(this, e.target.value)}
            buttons={[]}
          />
          <ComponentSelector
            selectedTab={this.state.selectedTab}
            updateSelectedTab={this.selectTab}
            tabs={[
              { title: "drivers_drivers", component: <DriversTable search={this.state.search} /> },
              {
                title: "drivers_groupsDrivers",
                component: <GroupsTable search={this.state.search} />,
              },
            ]}
          />
        </div>
      </div>
    );
  }
}

export default Drivers;
